<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="333"
      show-footer
      :footer-method="() => footerData"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="validRules"
      border
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('table_label_transferDetail') || '转库单明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="openchooseMaterialBatchVisible"
            v-if="!disabled"
          >
            <i class="el-icon-plus" />
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="batchDelShare()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <ChooseMaterialBatch
      :visible.sync="chooseMaterialBatchVisible"
      :extraData="{}"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseBookingConfirm"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, format } from '@/libs/util.number.js'

import ChooseMaterialBatch from '@/views/factory/inventory/components/choose-material-batch'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { ChooseMaterialBatch },
  mixins: [EditLoading],
  props: {
    shipmentExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.v_tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[0] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      statementOptionalVisible: false,
      chooseMaterialBatchVisible: false,
      format: (number) => format(number),
      validRules: {
        quantity: [
          {
            required: true,
            type: 'number',
            message:
              this.$l('INDEX.tip_pe_Please_enter_quantity') || '请输入数量',
          },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    async validate() {
      const data = this.getTableData()
      if (!data || !data.length) {
        this.$message({
          message:
            this.$l('form_label_tip_add_transfer_details') ||
            '请添加转库单明细',
          type: 'warning',
        })
        return false
      }
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    batchDelShare() {
      this.$refs.itemTable.removeCheckboxRow()
      this.reassign()
    },
    del(row) {
      this.$refs.itemTable.remove(row)
      this.reassign()
    },
    openchooseMaterialBatchVisible() {
      this.chooseMaterialBatchVisible = true
    },
    chooseBookingConfirm(params) {
      var infos = params
        .map((t) => ({
          materialCode: t.materialBatchCode,
          materialNo: t.materialBatchNo,
          materialName: t.materialBatchName,
          materialSpec: t.materialBatchSpec,
          materialUnit: t.materialBatchUnit,
          materialDisplayName: t.materialBatchDisplayName,
          ncMaterialNo: t.ncMaterialNo,
          quantity: t.quantity,
          orderCode: t.orderCode,
          orderNo: t.orderNo,
        }))
        .filter(
          (i) =>
            this.v_tableData.findIndex(
              (j) => j.materialCode === i.materialCode
            ) < 0
        )
      const $itemTable = this.$refs.itemTable
      infos.map(async (item) => {
        await $itemTable.insertAt({ ...item }, -1)
      })
      this.reassign()
    },

    reassign() {
      this.v_tableData = this.getTableData()
    },
  },
}
</script>
